import styled from '@emotion/styled';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { Box, IconButton } from '@mui/material';

import { useAuth } from '@/hooks/auth/useAuth';
import { useSidebarStore } from '@/stores/sidebar';

const StyledSidebarHeader = styled.div`
  min-height: 95px;
  display: flex;
  align-items: center;
  padding: 0 11px;
  width: 100%;

  > div {
    width: 100%;
    overflow: hidden;
  }
`;

export const SidebarHeader = ({ ...rest }) => {
  const { orgMetadata, orgName } = useAuth();
  const { isCollapsed, toggleCollapsed } = useSidebarStore();

  // const dontRenderFaviconCaption =
  //   orgMetadata?.['favicon_dont_render_text'] &&
  //   orgMetadata?.['favicon_svg_url'];

  return isCollapsed ? (
    <Box
      display="flex"
      width="100%"
      justifyContent="center"
      flexDirection="column"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          marginTop: 1.5,
        }}
      >
        <img
          style={{
            maxHeight: '70px',
            width: '90%',
            padding: '5%',
            aspectRatio: 'auto',
          }}
          src={orgMetadata?.['favicon_svg_url'] ?? '/favicon.svg'}
          alt={`${orgName ?? 'organization'} logo`}
        />
      </Box>
      <IconButton
        aria-label="Expand Sidebar"
        aria-expanded={false}
        sx={{
          alignSelf: 'center',
        }}
        onClick={() => toggleCollapsed()}
      >
        <MenuOutlinedIcon />
      </IconButton>
    </Box>
  ) : (
    <StyledSidebarHeader {...rest}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
        }}
      >
        <Box
          width="100%"
          sx={{
            maxHeight: '160px',
            minHeight: '46px',
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img
            style={{
              maxHeight: '100px',
              maxWidth: '100%',
              padding: '5%',
              marginTop: '24px',
              aspectRatio: 'auto', // or you can specify the aspect ratio like '16 / 9'
            }}
            src={orgMetadata?.['favicon_svg_url'] ?? '/favicon.svg'}
            alt={`${orgName ?? 'organization'} logo`}
          />

          <IconButton
            aria-label="Collapse Sidebar"
            aria-expanded
            sx={{
              position: 'absolute',
              top: (theme) => theme.spacing(0.5),
              right: (theme) => theme.spacing(0.5),
            }}
            onClick={() => toggleCollapsed()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        </Box>
      </div>
    </StyledSidebarHeader>
  );
};
